<template>
  <footer class="app-footer">
    <div class="footer-content">
      <div class="footer-info">
        <h3>北京洁丽雅保洁有限公司</h3>
        <p>地址：北京市西城区莲花池东路106号汇融大厦B座2103室</p>
        <p>总部电话：010-63967431</p>
        <p>家政电话：15699771333</p>
        <p>广招合伙人：15699771333</p>
        <!-- <p>邮箱：service@jiely.com</p> -->
      </div>
      <div class="footer-links">
        <h4>快速导航</h4>
        <ul>
          <li><router-link to="/">首页</router-link></li>
          <li><router-link to="/about">关于我们</router-link></li>
          <li><router-link to="/project-experience">项目经验</router-link></li>
          <li><router-link to="/news">新闻动态</router-link></li>
          <li><router-link to="/career">联系我们</router-link></li>
        </ul>
      </div>
      <div class="footer-social">
        <h4>关注我们</h4>
        <div class="social-icons">
          <!-- <img src="@/assets/social/wechat.png" alt="微信" />
          <img src="@/assets/social/weibo.png" alt="微博" /> -->
          <img style='width:200px;height:200px;margin-left:88px' src='../assets/images/newfolder/8.jpg'   />
        </div>
      </div>
    </div>
    <div class="footer-copyright">
      <p>© 2025 北京洁丽雅保洁有限公司 版权所有 | 京ICP备14037482号-1</p>
      <p>网站建设：雅思汀娜（北京）科技有限公司 | 技术支持：IT部门</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style scoped>
.app-footer {
  background-color: #2c3e50;
  color: #ffffff;
  padding: 60px 40px 30px;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  margin-bottom: 40px;
}

.footer-info h3 {
  font-size: 1.6em;
  margin-bottom: 20px;
}

.footer-info p {
  line-height: 1.8;
  color: #f0f0f0;
}

.footer-links h4,
.footer-social h4 {
  font-size: 1.4em;
  margin-bottom: 15px;
}

.footer-links ul {
  list-style: none;
  padding: 0;
}

.footer-links li {
  margin-bottom: 20px;
}

.footer-links a {
  color: #f0f0f0;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-links a:hover {
  color: #42b983;
}

.social-icons {
  display: flex;
  gap: 20px;
}

.social-icons img {
  width: 32px;
  height: 32px;
  opacity: 0.8;
  transition: opacity 0.3s ease;
}

.social-icons img:hover {
  opacity: 1;
}

.footer-copyright {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #475669;
}

.footer-copyright p {
  color: #cccccc;
  font-size: 0.9em;
  margin: 5px 0;
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    text-align: center;
  }
  .social-icons {
    justify-content: center;
  }
  .footer-links ul {
    margin: 0;
  }
}
</style>